import React from 'react';
import { EmptyCell } from './empty-cell.component';
import { Header } from './header.component';

type TMaterialHeaderProps = {
  hasMaterial: boolean;
};

export const MaterialHeader: React.FC<TMaterialHeaderProps> = ({ hasMaterial }) =>
  hasMaterial ? <Header title="Материал" /> : <EmptyCell />;
